import { useLocation } from 'react-router';
import { DASHBOARDS_PATH } from '../routes/paths';

/** True when the current route is the dashboard mode (`/dashboards/*`). */
export const useIsDashboardMode = (): boolean => useLocation().pathname.startsWith(DASHBOARDS_PATH);
